export default __webpack_public_path__ + "static/media/pof-other.f81c5e9f.png";